import React, { useEffect, useState } from 'react';
import './styles.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import Header from './components/Header';
// import Nav from './components/Nav';
import Forms from './pages/Forms';
import StudentsData from './pages/StudentsData';
import Login from './pages/Login';
import FacilitatorSignup from './pages/Facilitator_Signup';
import Report from './pages/Report';
import AreaLeaderSignup from './pages/AreaLeader_Signup';
import Requests from './pages/Requests';
import AllocateFacilitator from './pages/Allocate_Facilitators';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    const token = Cookies.get('token');
    setIsLoggedIn(!!token); // Convert to boolean: true if token exists
  }, []);

  if (isLoggedIn === null) {
    return <div>Loading...</div>; // Optional loading screen
  }

  return (
    <BrowserRouter>
       <Routes>
        {/* Public Routes */}
        {!isLoggedIn && (
          <>
            <Route path="/login" element={<Login onLogin={() => setIsLoggedIn(true)} />} />
            <Route path="/facilitator-signup" element={<FacilitatorSignup />} />
            <Route path="/area_leader-signup" element={<AreaLeaderSignup />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}

        {/* Protected Routes */}
        {isLoggedIn && (
          <>
            <Route
              path="*"
              element={
                <>
                  <Header />
                  <div className="main-container">
                    {/* <Nav /> */}
                    <div className="page-container">
                      <Routes>
                        {/* <Route path="/" element={<Forms />} /> */}
                        <Route path="/forms" element={<Forms />} />
                        {/* <Route path="/eventtickets" element={<Eventtickets />} /> */}
                        <Route path="/report" element={<Report />} />
                        {/* <Route path="/collegeactivities" element={<Collegeactivities />} /> */}
                        {/* <Route path="/members" element={<Members />} /> */}
                        {/* <Route path="/settings" element={<Settings />} /> */}
                        <Route path="/students-data" element={<StudentsData/>} />
                        <Route path="/requests" element={<Requests/>} />                  
                        <Route path="/Allocate" element={<AllocateFacilitator/>} />                  
                        <Route path="/add-data" element={<add-data/>} />                  
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </div>
                  </div>
                </>
              }
            />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;